export default __webpack_public_path__ + "static/Joerg_weiss_4x3_240px-e2218426a185c825d41bcc5d81863419.png";